import http from './httpClient';

const Safescarf = {
  // SAFESCARF_PRODUCT_TYPES
  createSafescarfProductType(data: Record<string, unknown>) {
    return http.post(`${import.meta.env.VITE_SAFESCARF_V0_BASE}/product-types`, data);
  },

  fetchSafescarfProductTypes() {
    return http.get(`${import.meta.env.VITE_SAFESCARF_V0_BASE}/product-types`);
  },

  updateSafescarfProductType(data: Record<string, unknown> & { id: string }) {
    return http.put(`${import.meta.env.VITE_SAFESCARF_V0_BASE}/product-types/${data.id}`, data);
  },

  // SAFESCARF_PRODUCTS
  createSafescarfProduct(data: Record<string, unknown>) {
    return http.post(`${import.meta.env.VITE_SAFESCARF_V0_BASE}/products`, data);
  },

  fetchSafescarfProducts(productId?: unknown) {
    return http.get(`${import.meta.env.VITE_SAFESCARF_V0_BASE}/products`, {
      params: { productId },
    });
  },

  updateSafescarfProduct(data: Record<string, unknown> & { id: string }) {
    return http.put(`${import.meta.env.VITE_SAFESCARF_V0_BASE}/products/${data.id}`, data);
  },

  deleteSafescarfProduct(id: string) {
    return http.delete(`${import.meta.env.VITE_SAFESCARF_V0_BASE}/products/${id}`);
  },

  // SAFESCARF_USERS
  createSafescarfUser(data: Record<string, unknown>) {
    return http.post(`${import.meta.env.VITE_SAFESCARF_V0_BASE}/users`, data);
  },

  fetchSafescarfUsers(params?: Record<string, unknown>) {
    return http.get(`${import.meta.env.VITE_SAFESCARF_V0_BASE}/users`, { params });
  },

  updateSafescarfUser(data: Record<string, unknown> & { id: string }) {
    return http.put(`${import.meta.env.VITE_SAFESCARF_V0_BASE}/users/${data.id}`, data);
  },

  fetchSafescarfUserProfile(username: string) {
    return http.get(`${import.meta.env.VITE_SAFESCARF_V0_BASE}/users/${username}`);
  },

  // SAFESCARF_PRODUCT_TYPE_MEMBERS
  fetchSafescarfProductTypeMembers(productTypeId: string) {
    return http.get(`${import.meta.env.VITE_SAFESCARF_V0_BASE}/product-type-members`, {
      params: { productTypeId },
    });
  },

  updateProductTypeMemberRole(data: Record<string, unknown>) {
    return http.post(`${import.meta.env.VITE_SAFESCARF_V0_BASE}/product-type-members`, data);
  },

  // SAFESCARF_PRODUCT_MEMBERS
  fetchSafescarfProductMembers(productId: unknown) {
    return http.get(`${import.meta.env.VITE_SAFESCARF_V0_BASE}/product-members`, {
      params: { productId },
    });
  },

  updateProductMemberRole(data: Record<string, unknown>) {
    return http.post(`${import.meta.env.VITE_SAFESCARF_V0_BASE}/product-members`, data);
  },

  // SAFESCARF_ROLES
  fetchSafescarfRoles() {
    return http.get(`${import.meta.env.VITE_SAFESCARF_V0_BASE}/roles`);
  },

  // SAFESCARF_MACHINE_ACCOUNTS
  fetchMachineAccounts() {
    return http.get(`${import.meta.env.VITE_SAFESCARF_V0_BASE}/users/machine-account`);
  },

  createMachineAccount() {
    return http.post(`${import.meta.env.VITE_SAFESCARF_V0_BASE}/users/machine-account`);
  },

  fetchSafescarfInstance() {
    return http.get(`${import.meta.env.VITE_SAFESCARF_V0_BASE}/instance`, {
      validateStatus: status => (status >= 200 && status < 300) || status === 404 || status === 403,
    });
  },

  fetchFQDNAvailability(fqdn: string) {
    return http.get(`${import.meta.env.VITE_SAFESCARF_V0_BASE}/fqdn/${fqdn}`);
  },
};

export default Safescarf;
